import React, { useState } from "react";
import ReviewCard from "./ReviewCard";
import { REVIEWS } from "../data/reviews";
import { useLanguage } from "../i18n/LanguageContext";
import { BUSINESS } from "../lib/constants";
import { ChevronLeft, ChevronRight, Star, ArrowUpRight } from "lucide-react";

const ReviewsSection = () => {
    const { t } = useLanguage();
    const [page, setPage] = useState(0);
    const perPage = 3;
    const totalPages = Math.ceil(REVIEWS.length / perPage);
    const slice = REVIEWS.slice(page * perPage, page * perPage + perPage);

    return (
        <section
            data-testid="reviews-section"
            className="bg-[#F5F2E4] py-24 md:py-32"
        >
            <div className="max-w-[1400px] mx-auto px-6">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
                    <div>
                        <div className="font-label text-[11px] text-[#D4A95A] mb-5 flex items-center gap-2">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} size={14} fill="#D4A95A" stroke="#D4A95A" />
                            ))}
                            <span className="ml-2">{t.home.reviewsOverline}</span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#3D3D24] leading-[1.05] max-w-2xl">
                            {t.home.reviewsTitle}
                        </h2>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            data-testid="reviews-prev"
                            onClick={() => setPage((p) => (p - 1 + totalPages) % totalPages)}
                            className="w-12 h-12 border border-[#3D3D24] text-[#3D3D24] flex items-center justify-center hover:bg-[#3D3D24] hover:text-[#FFFFF3] transition-colors"
                            aria-label="Previous reviews"
                        >
                            <ChevronLeft size={18} />
                        </button>
                        <button
                            data-testid="reviews-next"
                            onClick={() => setPage((p) => (p + 1) % totalPages)}
                            className="w-12 h-12 border border-[#3D3D24] text-[#3D3D24] flex items-center justify-center hover:bg-[#3D3D24] hover:text-[#FFFFF3] transition-colors"
                            aria-label="Next reviews"
                        >
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {slice.map((r) => (
                        <ReviewCard key={r.id} review={r} testid={`review-card-${r.id}`} />
                    ))}
                </div>

                <div className="flex justify-center mt-10 gap-1.5">
                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i}
                            data-testid={`reviews-dot-${i}`}
                            onClick={() => setPage(i)}
                            className={`h-1.5 transition-all ${page === i ? "w-10 bg-[#D4A95A]" : "w-6 bg-[#3D3D24]/30"}`}
                            aria-label={`Page ${i + 1}`}
                        />
                    ))}
                </div>

                <div className="flex justify-center mt-12">
                    <a
                        data-testid="reviews-google-link"
                        href={BUSINESS.googleReviewsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 border border-[#3D3D24] text-[#3D3D24] px-8 py-3.5 font-label text-xs hover:bg-[#3D3D24] hover:text-[#FFFFF3] transition-colors"
                    >
                        {t.common.seeAllReviews}
                        <ArrowUpRight size={14} />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default ReviewsSection;
